import { ObjectCreator } from "../../../../../web-graphics";

export class SettingsParser {
  constructor() {}

  static parseRestFields(settings, defaultSettings, parsedFields, resultSettings) {
    if (settings === undefined || resultSettings === undefined) {
      return;
    }
    const settingsKeys = Object.getOwnPropertyNames(settings);
    for (const key of settingsKeys) {
      if (!parsedFields.includes(key) && typeof settings[key] !== "function") {
        resultSettings[key] = ObjectCreator.merge(settings[key], defaultSettings?.[key]);
      }
    }
    if (defaultSettings !== undefined) {
      for (const key of Object.getOwnPropertyNames(defaultSettings)) {
        if (!settingsKeys.includes(key) && !parsedFields.includes(key) && typeof settings[key] !== "function") {
          resultSettings[key] = ObjectCreator.deepCopy(defaultSettings[key]);
        }
      }
    }
  }

  static parseChildItems(itemsSettings, defaultItemSettings, parser, successAction) {
    for (let itemIndex = 0; itemIndex < itemsSettings.length; itemIndex++) {
      let parsedSettings = parser.parse(itemsSettings[itemIndex], defaultItemSettings);
      if (parsedSettings !== undefined) {
        successAction(parsedSettings);
      }
    }
  }

  parse(/*settings, defaultSettings*/) {
    return undefined;
  }
}
